import React, { useState } from "react";
import { api } from "../lib/api";
import { Save, RotateCcw, Check } from "lucide-react";

function TextRow({ item, onChange }) {
  const [value, setValue] = useState(item.value);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/texts/${item.key}`, { value });
      setSaved(true);
      setTimeout(() => setSaved(false), 1600);
      await onChange();
    } catch (e) {
      alert(e?.response?.data?.detail || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  const reset = async () => {
    setBusy(true);
    try {
      const res = await api.delete(`/admin/texts/${item.key}`);
      setValue(res.data.value);
      await onChange();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-3 py-4 border-b border-cream-dark last:border-0">
      <div className="flex-1">
        <label className="font-sans text-[10px] tracking-wide-nav uppercase text-charcoal/55 mb-1.5 block">
          {item.label}
          {item.dirty && <span className="ml-2 text-gold">• Pending</span>}
        </label>
        <input
          className="w-full bg-cream/50 border border-cream-dark px-3 py-2.5 font-sans text-sm text-navy focus:border-gold focus:outline-none transition-colors"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div className="flex items-center gap-2">
        <button onClick={save} disabled={busy} className="inline-flex items-center gap-2 bg-navy text-cream px-5 py-2.5 font-sans text-[11px] tracking-wide-nav uppercase hover:bg-gold hover:text-navy transition-colors disabled:opacity-60">
          {saved ? <><Check size={13} /> Saved</> : <><Save size={13} /> Save</>}
        </button>
        {(item.overridden || item.dirty) && (
          <button onClick={reset} disabled={busy} title="Reset to default" className="inline-flex items-center gap-1 text-charcoal/55 px-2 py-2.5 font-sans text-[11px] tracking-wide-nav uppercase hover:text-navy transition-colors">
            <RotateCcw size={13} />
          </button>
        )}
      </div>
    </div>
  );
}

export default function TextManager({ texts, onChange }) {
  const groups = [];
  const map = {};
  texts.forEach((t) => {
    if (!map[t.group]) { map[t.group] = []; groups.push(t.group); }
    map[t.group].push(t);
  });

  return (
    <div className="space-y-10">
      {groups.map((g) => (
        <div key={g} className="bg-white border border-cream-dark p-6 md:p-8">
          <h3 className="font-serif text-2xl text-navy mb-1">{g}</h3>
          <div className="w-12 h-px bg-gold mb-4" />
          {map[g].map((item) => (
            <TextRow key={item.key} item={item} onChange={onChange} />
          ))}
        </div>
      ))}
    </div>
  );
}
